import { isNull, isUndefined } from 'lodash';
import getExcludedErrors from 'src/utils/getExcludedErrors';

const getDeviceErrorList = (errorCode: any = '', returnAll: boolean = false, controllerType = 'TR03') => {
  const excludedErrorsRaw = !isUndefined(getExcludedErrors) ? getExcludedErrors() : [];
  const excludedErrors = Array.isArray(excludedErrorsRaw) ? new Set(excludedErrorsRaw.map(Number)) : new Set();
  let deviceErrorList: any = [];
  if (localStorage.getItem('locale')) {
    const locale = localStorage.getItem('locale');

    if (window.location.pathname?.indexOf('heat_pump') !== -1 || controllerType === 'HEAT_PUMP') {
      const heatPumpAlarmList = [
        { 1: 'heat_pump_E001_alarm_name' },
        { 2: 'heat_pump_E002_alarm_name' },
        { 3: 'heat_pump_E003_alarm_name' },
        { 4: 'heat_pump_E004_alarm_name' },
        { 5: 'heat_pump_E005_alarm_name' },
        { 6: 'heat_pump_E006_alarm_name' },
        { 20: 'heat_pump_E020_alarm_name' },
        { 21: 'heat_pump_E021_alarm_name' },
        { 22: 'heat_pump_E022_alarm_name' },
        { 23: 'heat_pump_E023_alarm_name' },
        { 40: 'heat_pump_E040_alarm_name' },
        { 41: 'heat_pump_E041_alarm_name' },
        { 44: 'heat_pump_E044_alarm_name' },
        { 45: 'heat_pump_E045_alarm_name' },
        { 46: 'heat_pump_E046_alarm_name' },
        { 47: 'heat_pump_E047_alarm_name' },
        { 101: 'heat_pump_E101_alarm_name' },
        { 103: 'heat_pump_E103_alarm_name' },
        { 105: 'heat_pump_E105_alarm_name' },
        { 106: 'heat_pump_E106_alarm_name' },
        { 107: 'heat_pump_E107_alarm_name' },
        { 108: 'heat_pump_E108_alarm_name' },
        { 109: 'heat_pump_E109_alarm_name' },
        { 110: 'heat_pump_E110_alarm_name' },
        { 111: 'heat_pump_E111_alarm_name' },
        { 114: 'heat_pump_E114_alarm_name' },
        { 115: 'heat_pump_E115_alarm_name' },
        { 117: 'heat_pump_E117_alarm_name' },
        { 120: 'heat_pump_E120_alarm_name' },
        { 122: 'heat_pump_E122_alarm_name' },
        { 123: 'heat_pump_E123_alarm_name' },
        { 130: 'heat_pump_E130_alarm_name' },
        { 132: 'heat_pump_E132_alarm_name' },
        { 133: 'heat_pump_E133_alarm_name' },
        { 196: 'heat_pump_E196_alarm_name' },
        { 201: 'heat_pump_E201_alarm_name' },
        { 203: 'heat_pump_E203_alarm_name' },
        { 205: 'heat_pump_E205_alarm_name' },
        { 206: 'heat_pump_E206_alarm_name' },
        { 207: 'heat_pump_E207_alarm_name' },
        { 208: 'heat_pump_E208_alarm_name' },
        { 209: 'heat_pump_E209_alarm_name' },
        { 210: 'heat_pump_E210_alarm_name' },
        { 211: 'heat_pump_E211_alarm_name' },
        { 214: 'heat_pump_E214_alarm_name' },
        { 215: 'heat_pump_E215_alarm_name' },
        { 217: 'heat_pump_E217_alarm_name' },
        { 220: 'heat_pump_E220_alarm_name' },
        { 222: 'heat_pump_E222_alarm_name' },
        { 223: 'heat_pump_E223_alarm_name' },
        { 230: 'heat_pump_E230_alarm_name' },
        { 232: 'heat_pump_E232_alarm_name' },
        { 233: 'heat_pump_E233_alarm_name' },
        { 296: 'heat_pump_E296_alarm_name' },
        { 901: 'heat_pump_E901_alarm_name' },
        { 902: 'heat_pump_E902_alarm_name' },
        { 903: 'heat_pump_E903_alarm_name' },
        { 904: 'heat_pump_E904_alarm_name' },
        { 910: 'heat_pump_E910_alarm_name' },
        { 920: 'heat_pump_E920_alarm_name' },
        { 921: 'heat_pump_E921_alarm_name' },
        { 930: 'heat_pump_E930_alarm_name' },
        { 931: 'heat_pump_E931_alarm_name' },
      ];

      if (returnAll) {
        return heatPumpAlarmList;
      }

      if (isUndefined(errorCode) || isNull(errorCode) || errorCode.toString().trim() === '') return '';

      const parsedAlarmCode = parseInt(errorCode, 10);
      const selectedAlarm = heatPumpAlarmList.find((obj: any) => Number(Object.keys(obj)[0]) === parsedAlarmCode);

      if (selectedAlarm) {
        return selectedAlarm[parsedAlarmCode] || parsedAlarmCode;
      }

      return '';
    }

    // TR04 for Non-Dutch Languages (en, de, dk, fr)
    if (controllerType === 'TR04' && ['en', 'de', 'dk', 'fr']?.includes(locale)) {
      deviceErrorList = [
        { 0: 'E2PROM_READ_ERROR' },
        { 8: 'RAM_ERROR' },
        { 10: 'E2PROM_ERROR' },
        { 11: 'STATE_ERROR' },
        { 12: 'ROM_ERROR' },
        { 15: 'MAX_TEMP_ERROR' },
        { 17: 'STACK_ERROR' },
        { 18: 'INSTRUCTION_ERROR' },
        { 23: 'CORRUPTED_ERROR_NR' },
        { 29: 'PSM_ERROR' },
        { 30: 'REGISTER_ERROR' },
        { 37: 'ADC_ERROR' },
        { 39: 'E2PROM_VERSION_CHECK_ERROR' },
        { 106: 'REFHI_TOO_HIGH' },
        { 107: 'REFHI_TOO_LOW' },
        { 108: 'REFLO_TOO_HIGH' },
        { 109: 'REFLO_TOO_LOW' },
        { 114: 'E2PROM_VERSION_ERROR' },
        { 116: 'LOW_WATER_PRESSURE_SENSOR' },
        { 119: 'T_PRIMARY_CH_RETURN_OPEN' },
        { 120: 'T_PRIMARY_SUPPLY_OPEN' },
        { 122: 'T_DHW_OUT_OPEN' },
        { 126: 'T_PRIMARY_CH_RETURN_SHORTED' },
        { 127: 'T_PRIMARY_SUPPLY_SHORTED' },
        { 129: 'T_DHW_OUT_SHORTED' },
        { 134: 'RESET_BUTTON_ERROR' },
        { 158: 'T_SECONDARY_CH_SUPPLY_OPEN' },
        { 159: 'T_SECONDARY_CH_RETURN_OPEN' },
        { 160: 'T_SECONDARY_CH_SUPPLY_SHORTED' },
        { 161: 'T_SECONDARY_CH_RETURN_SHORTED' },
        { 171: 'ADC_UNSTABLE' },
        { 174: 'T_PRIMARY_DHW_RETURN_OPEN' },
        { 175: 'T_PRIMARY_DHW_RETURN_SHORTED' },
        { 203: 'HIGH_WATER_PRESSURE_SENSOR' },
        { 206: 'TE_BOOSTER_WARNING' },
        { 207: 'POWERPACK_DEFECT_WARNING' },
        { 208: 'ERRORLOG_STORAGE_FAULT' },
        { 209: 'DATALOG_STORAGE_FAULT' },
        { 210: 'FIRMWARE_STORAGE_FAULT' },
        { 211: 'DEFAULTS_STORAGE_FAULT' },
        { 212: 'NO_PRIMARY_FLOW' },
        { 213: 'LOW_PRIMARY_FLOW' },
        { 214: 'UNDESIRED_PRIMARY_FLOW_MCV1' },
        { 215: 'UNDESIRED_PRIMARY_FLOW_MCV1_2' },
        { 216: 'T_ALEG_TOO_LOW' },
        { 217: 'T_DHW_TOO_HIGH' },
        { 218: 'EVALUATION_TIMER_EXPIRED' },
        { 219: 'WATER_LEAK' },
        { 255: 'NO_ERROR' },
        { 256: 'MODBUS_WARNING_MESSAGE' }
      ];
    }

    // TR03 for Non-Dutch Languages (en, de, dk, fr)
    if (controllerType === 'TR03' && ['en', 'de', 'dk', 'fr']?.includes(locale)) {
      deviceErrorList = [
        { 0: 'E2PROM_READ_ERROR' },
        { 4: 'BLOCKING_TOO_LONG' },
        { 8: 'RAM_ERROR' },
        { 9: 'WRONG_EEPROM_SIGNATURE' },
        { 10: 'E2PROM_ERROR' },
        { 11: 'STATE_ERROR' },
        { 12: 'ROM_ERROR' },
        { 15: 'MAX_TEMP_ERROR' },
        { 17: 'STACK_ERROR' },
        { 18: 'INSTRUCTION_ERROR' },
        { 23: 'CORRUPTED_ERROR_NR' },
        { 29: 'PSM_ERROR' },
        { 30: 'REGISTER_ERROR' },
        { 36: 'COOLING_TO_HIGH' },
        { 106: 'REFHI_TOO_HIGH' },
        { 107: 'REFHI_TOO_LOW' },
        { 108: 'REFLO_TOO_HIGH' },
        { 109: 'REFLO_TOO_LOW' },
        { 110: 'REFHI2_TOO_HIGH' },
        { 111: 'REFHI2_TOO_LOW' },
        { 112: 'REFLO2_TOO_HIGH' },
        { 113: 'REFLO2_TOO_LOW' },
        { 115: 'LOW_WATER_PRESSURE_ERROR' },
        { 116: 'LOW_WATER_PRESSURE_SENSOR' },
        { 119: 'RETURN_OPEN' },
        { 120: 'SUPPLY_OPEN' },
        { 121: 'SUPPLY2_OPEN' },
        { 122: 'DHW_OPEN' },
        { 126: 'RETURN_SHORTED' },
        { 127: 'SUPPLY_SHORTED' },
        { 128: 'SUPPLY2_SHORTED' },
        { 129: 'DHW_SHORTED' },
        { 134: 'RESET_BUTTON_ERROR' },
        { 167: 'RETURN2_SHORTED' },
        { 168: 'RETURN2_OPEN' },
        { 169: 'HEAT_COOL_ACTIVE' },
        { 170: 'HW_IDENTIFIER_ERROR' },
        { 203: 'HIGH_PRESSURE' },
        { 204: 'OUTDOOR_WRONG' },
        { 206: 'TE_BOOSTER_WARNING' },
        { 255: 'NO_ERROR' },
        { 256: 'MODBUS_WARNING_MESSAGE' }
      ];
    }

    // TR03 for Dutch Language (nl)
    if (controllerType === 'TR03' && locale === 'nl') {
      deviceErrorList = [
        { 0: 'E2PROM_LEES_STORING' },
        { 4: 'STORING_TE_LANG' },
        { 8: 'RAM_STORING' },
        { 9: 'VERKEERDE_EEPROM_SLEUTEL' },
        { 10: 'E2PROM_STORING' },
        { 11: 'STATUS_STORING' },
        { 12: 'ROM_STORING' },
        { 15: 'MAX_TEMP_STORING' },
        { 17: 'STACK_STORING' },
        { 18: 'INSTRUCTIE_STORING' },
        { 23: 'BESCHADIGING_STORING_NR' },
        { 29: 'PSM_STORING' },
        { 30: 'REGISTER_STORING' },
        { 36: 'KOELING_TE_HOOG' },
        { 106: 'REFHI_TE_HOOG' },
        { 107: 'REFHI_TE_LAAG' },
        { 108: 'REFLO_TE_HOOG' },
        { 109: 'REFLO_TE_LAAG' },
        { 110: 'REFHI2_TE_HOOG' },
        { 111: 'REFHI2_TE_LAAG' },
        { 112: 'REFLO2_TE_HOOG' },
        { 113: 'REFLO2_TE_LAAG' },
        { 115: 'LAGE_WATERDRUK_STORING' },
        { 116: 'LAGE_WATERDRUK_SENSOR' },
        { 119: 'T_RETOUR_OPEN' },
        { 120: 'T_AANVOER_OPEN' },
        { 121: 'T_SEC_AANVOER_OPEN' },
        { 122: 'T_TAPWATER_OPEN' },
        { 126: 'T_RETOUR_KORTSL' },
        { 127: 'T_AANVOER_KORTSL' },
        { 128: 'T_SEC_AANVOER_KORTSL' },
        { 129: 'T_TAPWATER_KORTSL' },
        { 134: 'RESETKNOP_STORING' },
        { 167: 'T_SEC_RETOUR_KORTSL' },
        { 168: 'T_SEC_RETOUR_OPEN' },
        { 169: 'WARMTE_KOELING_ACTIEF' },
        { 170: 'HW_IDENTIFICATIE_STORING' },
        { 203: 'HOGE_DRUK' },
        { 204: 'KORTSL_BUITENTEMP_SENSOR' },
        { 206: 'TE_BOOSTER_WAARSCHUWING' },
        { 255: 'GEEN_STORING' },
        { 256: 'MODBUS_WAARSCH_BERICHT' }
      ];
    }

    // TR04 for Dutch Language (nl)
    if (controllerType === 'TR04' && locale === 'nl') {
      deviceErrorList = [
        { 0: 'E2PROM_LEES_STORING' },
        { 8: 'RAM_STORING' },
        { 10: 'E2PROM_STORING' },
        { 11: 'STATUS_STORING' },
        { 12: 'ROM_STORING' },
        { 15: 'MAX_TEMP_STORING' },
        { 17: 'STACK_STORING' },
        { 18: 'INSTRUCTIE_STORING' },
        { 23: 'BESCHADIGING_STORING_NR' },
        { 29: 'PSM_STORING' },
        { 30: 'REGISTER_STORING' },
        { 37: 'ADC_STORING' },
        { 39: 'E2PROM_VERSIE_CHECK_STORING' },
        { 106: 'REFHI_TE_HOOG' },
        { 107: 'REFHI_TE_LAAG' },
        { 108: 'REFLO_TE_HOOG' },
        { 109: 'REFLO_TE_LAAG' },
        { 114: 'E2PROM_VERSIE_STORING' },
        { 116: 'LAGE_WATER_DRUK_STORING' },
        { 119: 'TEMP_PRIMAIR_RETOUR_CV_OPEN' },
        { 120: 'T_PRIMAIR_AANVOER_OPEN' },
        { 122: 'T_SWW_UIT_OPEN' },
        { 126: 'T_PRIMAIR_RETOUR_CV_KORTSL' },
        { 127: 'T_PRIMAIR_AANVOER_KORTSL' },
        { 129: 'T_SWW_UIT_KORTSL' },
        { 134: 'RESET_KNOP_STORING' },
        { 158: 'T_SECONDAIR_AANV_CV_OPEN' },
        { 159: 'SEC_RETOUR_CV_TEMP_OPEN' },
        { 160: 'SECONDAIRE_AANV_CV_TEMP_KORTSL' },
        { 161: 'SEC_RETOUR_CV_TEMP_KORTSL' },
        { 171: 'ADC_ONSTABIEL' },
        { 174: 'PRIMAIRE_RETOUR_SWW_TEMP_OPEN' },
        { 175: 'PRIMAIRE_RETOUR_SWW_TEMP_KORTSL' },
        { 203: 'HOGE_DRUK' },
        { 206: 'TE_BOOSTER_WAARSCHUWING' },
        { 207: 'POWERPACK_DEFECT_WAARSCHUWING' },
        { 208: 'STORINGSLOG_OPSLAG_FOUT' },
        { 209: 'DATALOG_OPSLAG_FOUT' },
        { 210: 'FIRMWARE_OPSLAG_FOUT' },
        { 211: 'STANDAARDINSTELLINGEN_OPSLAG_FOUT' },
        { 212: 'GEEN_PRIMAIR_DEBIET' },
        { 213: 'LAGE_PRIMAIR_DEBIET' },
        { 214: 'ONTERECHTE_PRIMAIRE_DEBIET_MCV1' },
        { 215: 'ONTERECHTE_PRIMAIR_DEBIET_MCV1_2' },
        { 216: 'TEMP_ALEG_TE_LAAG' },
        { 217: 'TEMP_TAPW_TE_HOOG' },
        { 218: 'EVALUATION_TIMER_EXPIRED' },
        { 219: 'WATER_LEKKAGE' },
        { 255: 'GEEN_STORING' },
        { 256: 'MODBUS_WAARSCH_BERICHT' }
      ];
    }

    /*
    if (['en', 'de', 'dk', 'fr']?.includes(locale)) {
      deviceErrorList = [
        { 0: 'E2PROM_READ_ERROR' },
        { 4: 'BLOCKING_TOO_LONG' },
        { 8: 'RAM_ERROR' },
        { 9: 'WRONG_EEPROM_SIGNATURE' },
        { 10: 'E2PROM_ERROR' },
        { 11: 'STATE_ERROR' },
        { 12: 'ROM_ERROR' },
        { 15: 'MAX_TEMP_ERROR' },
        { 17: 'STACK_ERROR' },
        { 18: 'INSTRUCTION_ERROR' },
        { 23: 'CORRUPTED_ERROR_NR' },
        { 29: 'PSM_ERROR' },
        { 30: 'REGISTER_ERROR' },
        { 36: 'COOLING_TO_HIGH' },
        { 37: 'ADC_ERROR' },
        { 39: 'E2PROM_VERSION_CHECK_ERROR' },
        { 106: 'REFHI_TOO_HIGH' },
        { 107: 'REFHI_TOO_LOW' },
        { 108: 'REFLO_TOO_HIGH' },
        { 109: 'REFLO_TOO_LOW' },
        { 110: 'REFHI2_TOO_HIGH' },
        { 111: 'REFHI2_TOO_LOW' },
        { 112: 'REFLO2_TOO_HIGH' },
        { 113: 'REFLO2_TOO_LOW' },
        { 114: 'E2PROM_VERSION_ERROR' },
        { 115: 'LOW_WATER_PRESSURE_ERROR' },
        { 116: 'LOW_WATER_PRESSURE_SENSOR' },
        { 119: 'RETURN_OPEN' },
        { 120: 'SUPPLY_OPEN' },
        { 121: 'SUPPLY2_OPEN' },
        { 122: 'DHW_OPEN' },
        { 126: 'RETURN_SHORTED' },
        { 127: 'SUPPLY_SHORTED' },
        { 128: 'SUPPLY2_SHORTED' },
        { 129: 'DHW_SHORTED' },
        { 134: 'RESET_BUTTON_ERROR' },
        { 158: 'T_SECONDARY_CH_SUPPLY_OPEN' },
        { 159: 'T_SECONDARY_CH_RETURN_OPEN' },
        { 160: 'T_SECONDARY_CH_SUPPLY_SHORTED' },
        { 161: 'T_SECONDARY_CH_RETURN_SHORTED' },
        { 167: 'RETURN2_SHORTED' },
        { 168: 'RETURN2_OPEN' },
        { 169: 'HEAT_COOL_ACTIVE' },
        { 170: 'HW_IDENTIFIER_ERROR' },
        { 171: 'ADC_UNSTABLE' },
        { 174: 'T_PRIMARY_DHW_RETURN_OPEN' },
        { 175: 'T_PRIMARY_DHW_RETURN_SHORTED' },
        { 203: 'HIGH_PRESSURE' },
        { 204: 'OUTDOOR_WRONG' },
        { 206: 'TE_BOOSTER_WARNING' },
        { 207: 'POWERPACK_DEFECT_WARNING' },
        { 208: 'ERRORLOG_STORAGE_FAULT' },
        { 209: 'DATALOG_STORAGE_FAULT' },
        { 210: 'FIRMWARE_STORAGE_FAULT' },
        { 211: 'DEFAULTS_STORAGE_FAULT' },
        { 212: 'NO_PRIMARY_FLOW' },
        { 213: 'LOW_PRIMARY_FLOW' },
        { 214: 'UNDESIRED_PRIMARY_FLOW_MCV1' },
        { 215: 'UNDESIRED_PRIMARY_FLOW_MCV1_2' },
        { 216: 'T_ALEG_TOO_LOW' },
        { 217: 'T_DHW_TOO_HIGH' },
        { 218: 'EVALUATION_TIMER_EXPIRED' },
        { 219: 'WATER_LEAK' },
        { 255: 'NO_ERROR' },
        { 256: 'MODBUS_WARNING_MESSAGE' }
      ];
      // deviceErrorList = [
      //   { 0: 'E2PROM_READ_ERROR' },
      //   { 4: 'BLOCKING_TOO_LONG' },
      //   { 8: 'RAM_ERROR' },
      //   { 9: 'WRONG_EEPROM_SIGNATURE' },
      //   { 10: 'E2PROM_ERROR' },
      //   { 11: 'STATE_ERROR' },
      //   { 12: 'ROM_ERROR' },
      //   { 15: 'MAX_TEMP_ERROR' },
      //   { 17: 'STACK_ERROR' },
      //   { 18: 'INSTRUCTION_ERROR' },
      //   { 23: 'CORRUPTED_ERROR_NR' },
      //   { 29: 'PSM_ERROR' },
      //   { 30: 'REGISTER_ERROR' },
      //   { 36: 'COOLING_TO_HIGH' },
      //   { 106: 'REFHI_TOO_HIGH' },
      //   { 107: 'REFHI_TOO_LOW' },
      //   { 108: 'REFLO_TOO_HIGH' },
      //   { 109: 'REFLO_TOO_LOW' },
      //   { 110: 'REFHI2_TOO_HIGH' },
      //   { 111: 'REFHI2_TOO_LOW' },
      //   { 112: 'REFLO2_TOO_HIGH' },
      //   { 113: 'REFLO2_TOO_LOW' },
      //   { 115: 'LOW_WATER_PRESSURE_ERROR' },
      //   { 116: 'LOW_WATER_PRESSURE_SENSOR' },
      //   { 119: 'RETURN_OPEN' },
      //   { 120: 'SUPPLY_OPEN' },
      //   { 121: 'SUPPLY2_OPEN' },
      //   { 122: 'DHW_OPEN' },
      //   { 126: 'RETURN_SHORTED' },
      //   { 127: 'SUPPLY_SHORTED' },
      //   { 128: 'SUPPLY2_SHORTED' },
      //   { 129: 'DHW_SHORTED' },
      //   { 134: 'RESET_BUTTON_ERROR' },
      //   { 167: 'RETURN2_SHORTED' },
      //   { 168: 'RETURN2_OPEN' },
      //   { 169: 'HEAT_COOL_ACTIVE' },
      //   { 170: 'HW_IDENTIFIER_ERROR' },
      //   { 203: 'HIGH_PRESSURE' },
      //   { 204: 'OUTDOOR_WRONG' },
      //   { 206: 'TE_BOOSTER_WARNING' },
      //   { 256: 'MODBUS_WARNING_MESSAGE' },
      //   { 255: 'NO_ERROR' }
      // ];
    } else if (locale === 'nl') {
      deviceErrorList = [
        { 0: 'E2PROM_LEES_STORING' },
        { 4: 'STORING_TE_LANG' },
        { 8: 'RAM_STORING' },
        { 9: 'VERKEERDE_EEPROM_SLEUTEL' },
        { 10: 'E2PROM_STORING' },
        { 11: 'STATUS_STORING' },
        { 12: 'ROM_STORING' },
        { 15: 'MAX_TEMP_STORING' },
        { 17: 'STACK_STORING' },
        { 18: 'INSTRUCTIE_STORING' },
        { 23: 'BESCHADIGING_STORING_NR' },
        { 29: 'PSM_STORING' },
        { 30: 'REGISTER_STORING' },
        { 36: 'KOELING_TE_HOOG' },
        { 37: 'ADC_STORING' },
        { 39: 'E2PROM_VERSIE_CHECK_STORING' },
        { 106: 'REFHI_TE_HOOG' },
        { 107: 'REFHI_TE_LAAG' },
        { 108: 'REFLO_TE_HOOG' },
        { 109: 'REFLO_TE_LAAG' },
        { 110: 'REFHI2_TE_HOOG' },
        { 111: 'REFHI2_TE_LAAG' },
        { 112: 'REFLO2_TE_HOOG' },
        { 113: 'REFLO2_TE_LAAG' },
        { 114: 'E2PROM_VERSIE_STORING' },
        { 115: 'LAGE_WATERDRUK_STORING' },
        { 116: 'LAGE_WATERDRUK_SENSOR' },
        { 119: 'T_RETOUR_OPEN' },
        { 120: 'T_AANVOER_OPEN' },
        { 121: 'T_SEC_AANVOER_OPEN' },
        { 122: 'T_TAPWATER_OPEN' },
        { 126: 'T_RETOUR_KORTSL' },
        { 127: 'T_AANVOER_KORTSL' },
        { 128: 'T_SEC_AANVOER_KORTSL' },
        { 129: 'T_TAPWATER_KORTSL' },
        { 134: 'RESETKNOP_STORING' },
        { 158: 'T_SECONDAIR_AANV_CV_OPEN' },
        { 159: 'SEC_RETOUR_CV_TEMP_OPEN' },
        { 160: 'SECONDAIRE_AANV_CV_TEMP_KORTSL' },
        { 161: 'SEC_RETOUR_CV_TEMP_KORTSL' },
        { 167: 'T_SEC_RETOUR_KORTSL' },
        { 168: 'T_SEC_RETOUR_OPEN' },
        { 169: 'WARMTE_KOELING_ACTIEF' },
        { 170: 'HW_IDENTIFICATIE_STORING' },
        { 171: 'ADC_ONSTABIEL' },
        { 174: 'PRIMAIRE_RETOUR_SWW_TEMP_OPEN' },
        { 175: 'PRIMAIRE_RETOUR_SWW_TEMP_KORTSL' },
        { 203: 'HOGE_DRUK' },
        { 204: 'KORTSL_BUITENTEMP_SENSOR' },
        { 206: 'TE_BOOSTER_WAARSCHUWING' },
        { 207: 'POWERPACK_DEFECT_WAARSCHUWING' },
        { 208: 'STORINGSLOG_OPSLAG_FOUT' },
        { 209: 'DATALOG_OPSLAG_FOUT' },
        { 210: 'FIRMWARE_OPSLAG_FOUT' },
        { 211: 'STANDAARDINSTELLINGEN_OPSLAG_FOUT' },
        { 212: 'GEEN_PRIMAIR_DEBIET' },
        { 213: 'LAGE_PRIMAIR_DEBIET' },
        { 214: 'ONTERECHTE_PRIMAIRE_DEBIET_MCV1' },
        { 215: 'ONTERECHTE_PRIMAIR_DEBIET_MCV1_2' },
        { 216: 'TEMP_ALEG_TE_LAAG' },
        { 217: 'TEMP_TAPW_TE_HOOG' },
        { 218: 'EVALUATION_TIMER_EXPIRED' },
        { 219: 'WATER_LEKKAGE' },
        { 255: 'GEEN_STORING' },
        { 256: 'MODBUS_WAARSCH_BERICHT' }
      ];
    }
    */
  }

  let filteredDeviceErrorList = deviceErrorList.filter((obj: any) => {
    const errorCodeKey = Number(Object.keys(obj)[0]);
    return !excludedErrors.has(errorCodeKey);
  });

  if (returnAll) {
    filteredDeviceErrorList = deviceErrorList.filter(
      (err) => !Object.keys(err).some((key) => Number(key) === 255)
    );
    return filteredDeviceErrorList;
  }

  if (isUndefined(errorCode) || isNull(errorCode) || errorCode.toString().trim() === '') return '';

  const parsedErrorCode = parseInt(errorCode, 10);
  const selectedError = filteredDeviceErrorList.find((obj: any) => Number(Object.keys(obj)[0]) === parsedErrorCode);

  if (errorCode?.toString()?.length > 0) {
    if (excludedErrors.has(errorCode)) {
      return 'errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorName';
    }
  }

  if (selectedError && parsedErrorCode !== 255) {
    return selectedError[parsedErrorCode] || parsedErrorCode;
  }

  return 'device_status_reg_105_no_error_255';
};

export default getDeviceErrorList;
